// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__Cd06v","block":"Footer_block__7o9+q","info":"Footer_info__ESv6T"};